import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function SetupRestaurantEn() {
  return (
    <>
      <Note>
        Only <L k="role.manager" /> and <L k="role.superuser" /> accounts can open these pages.
      </Note>
      <H2>Account levels</H2>
      <Ul>
        <li>Customer: no role; can open the home pages and order.</li>
        <li>
          <L k="role.staff" />: operates a branch (queue, sessions, order details, creating orders for customers). Works in chosen branches.
        </li>
        <li>
          <L k="role.admin" /> (branch manager): staff rights plus branch settings, branch menu, statistics, tables and staff of their branches.
        </li>
        <li>
          <L k="role.manager" /> (restaurant manager): everything above for every branch, plus the restaurant pages below. Can grant the{' '}
          <L k="role.staff" /> and <L k="role.admin" /> roles.
        </li>
        <li>
          <L k="role.superuser" />: the restaurant owner, the account that created the restaurant. Can also grant the <L k="role.manager" /> role.
        </li>
      </Ul>
      <P>A role can only be granted or revoked by someone with a higher role.</P>
      <H2>Opening the restaurant pages</H2>
      <P>
        Go to romi.io.vn/restaurant-url (replace “restaurant-url” with your real URL name) and log in, or log in and open the restaurant through{' '}
        <L k="nav.myRestaurants" />. Press <L k="landing.manageRestaurant" />.
      </P>
      <P>
        There are 6 management pages: <L k="nav.branches" />, <L k="nav.menu" />, <L k="nav.feedback" />, <L k="nav.accounts" />, <L k="nav.auditLog" /> and{' '}
        <L k="nav.settings" />.
      </P>
      <H2>Branches</H2>
      <P>
        Lists the restaurant’s branches; open one to reach its management pages. You can also add a branch (<L k="restaurants.addBranch" />) or deactivate an
        old one (<L k="restaurants.deactivate" />). A deactivated branch keeps only its statistics and can be reactivated later.
      </P>
      <H2>Menu</H2>
      <P>Manages menu categories and the items in them. Categories appear to customers in the order shown here; move them up or down as needed.</P>
      <Ul>
        <li>
          Press <L k="menu.addCategory" /> and name it (the main language is required, other languages are optional).
        </li>
        <li>
          Press <L k="menu.addItem" /> under a category.
        </li>
        <li>Name the item, pick its category and enter the price (in the branch currency; VND takes whole numbers only).</li>
        <li>
          <L k="menu.step" />: choose <L k="menu.step.whole" /> for items sold only as a whole, <L k="menu.step.half" /> for items that can be ordered by the
          half, such as half a duck or chicken, and <L k="menu.step.tenth" /> for items sold by weight, such as shrimp or crab that weighs in at 1.7 kg. The
          price is always per whole unit.
        </li>
        <li>Upload a picture (optional) and save.</li>
      </Ul>
      <H2>Feedback</H2>
      <P>Shows what customers wrote, from their orders and from the restaurant page.</P>
      <H2>Accounts</H2>
      <P>
        Manages everyone who works at the restaurant, such as making an account a <L k="role.manager" /> or <L k="role.admin" />. For <L k="role.staff" /> and{' '}
        <L k="role.admin" />, you also pick the branches that person works in.
      </P>
      <P>
        To add someone, they must register a Romi account first. Then search for that account by its exact phone number or email and press{' '}
        <L k="accounts.grant" />. Staff can also be added from a branch’s <L k="nav.staff" /> page.
      </P>
      <H2>Audit log</H2>
      <P>Shows who changed what, when you need to look back.</P>
      <H2>Settings</H2>
      <P>
        Change the restaurant name, the color used for buttons and the navigation bar, the languages supported for item names, and the introduction shown on the
        restaurant’s home page. The URL name cannot be changed.
      </P>
      <Note>
        When someone leaves, press <L k="accounts.revoke" /> on their role so they can no longer manage or operate the restaurant.
      </Note>
      <P>One more step, branch setup, and you are ready.</P>
    </>
  )
}
